<template>
  <div id="app">
    <div class="map-wrapper">
      <map-leaflet v-if="this.$root.places && this.$root.contentText"></map-leaflet>
      <map-filters v-if="this.$root.places && this.$root.contentText"
                   @categories="getCategories"
                   @types="getTypes"
      ></map-filters>
    </div>

    <div class="submap-wrapper">
      <slot v-slot="keys"></slot>
      <search-filters v-if="this.$root.places && this.$root.contentText" @searchfilter="getSearchFilter"></search-filters>
      <places-list v-if="this.$root.places && this.$root.contentText"></places-list>
    </div>

  </div>
</template>

<script>
  import mapLeaflet from './components/mapLeaflet.vue'
  import mapFilters from './components/mapFilters.vue'
  import searchFilters from './components/searchFilters.vue'
  import placesList from './components/placesList.vue'

  export default {
    name: 'mapManager',
    components: {
      mapLeaflet,
      mapFilters,
      searchFilters,
      placesList
    },
    data() {
      return {
        filterSearch: null,
        filterCat: ['commerce', 'mixity'],
        filterType: ['project', 'patrimony']
      }
    },
    methods: {
      getSearchFilter(value) {
        this.filterSearch = value
      },
      getCategories(value) {
        this.filterCat = value
      },
      getTypes(value) {
        this.filterType = value
      },
    }
  }
</script>

<style lang="scss">
  .map-wrapper {
    position: relative;
  }
</style>
